
const config = {
  MOBILE_WIDTH: 700
}

export default Object.freeze(config)
